module.exports = __webpack_public_path__ + "static/img/slide-2.add6ca3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-2.svg
// module id = JSsg
// module chunks = 1